<template>
  <section ref="slide" class="outerwrapper">
    <div class="headlinewrapper">
      <h2>Playground</h2>
      <h3>Lab, Archive, Experimental &amp; Fun</h3>
      <p>Most of these projects I wrote, to familiarize myself with the underlying principles or technology. 
        Although they're not perfect, they can be considered the starting point for me. Nevertheless, I would like to show them here.</p>
    </div>
    <th-tiles/>
  </section>
</template>

<script>
import ThTiles from '../components/ThTiles.vue';

export default {
  components: {
    ThTiles,
  },
};
</script>

<style lang="scss">
  @import '@/assets/scss/app.scss';
</style>
